import React from 'react';
import './PickupStatsCards.css';

const PickupStatsCards = ({ pickupStats, backlogCount = 0, variant }) => {
    const { totalAssigned, pickedUpToday, remaining, pickupRate, totalTasks = 0, completedTasks = 0 } = pickupStats || {};

    const getPickupRateColor = () => {
        if (pickupRate === 100) return 'green';
        if (pickupRate >= 50) return 'yellow';
        return 'red';
    };

    const getRemainingColor = () => {
        if (remaining === 0) return 'green';
        return 'red';
    };

    const getBacklogColor = () => {
        if (backlogCount === 0) return 'green';
        if (backlogCount <= 5) return 'yellow';
        return 'red';
    };

    const getCompletionColor = () => {
        if (totalTasks === 0) return 'gray';
        const completionRate = (completedTasks / totalTasks) * 100;
        if (completionRate === 100) return 'green';
        if (completionRate >= 50) return 'yellow';
        return 'red';
    };

    const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

    const isReport = variant === 'report';

    return (
        <div className={`pickup-stats-cards ${isReport ? 'pickup-stats-cards-report' : ''}`}>
            <div className="pickup-stats-header">
                <h2>Task Pickup Overview</h2>
            </div>
            <div className="pickup-stats-grid">
                <div className={`pickup-stat-card picked ${pickupRate === 100 ? 'green' : ''}`}>
                    <div className="stat-label">Picked Up Today</div>
                    <div className="stat-value">{pickedUpToday || 0}</div>
                    <div className="stat-sublabel">out of {totalAssigned || 0} assigned</div>
                </div>
                <div className={`pickup-stat-card remaining ${getRemainingColor()}`}>
                    <div className="stat-label">Remaining Assigned</div>
                    <div className="stat-value">{remaining || 0}</div>
                    <div className="stat-sublabel">tasks not picked up</div>
                </div>
                <div className={`pickup-stat-card backlog ${getBacklogColor()}`}>
                    <div className="stat-label">Unassigned Backlog</div>
                    <div className="stat-value">{backlogCount || 0}</div>
                    <div className="stat-sublabel">tasks not assigned</div>
                </div>
                <div className={`pickup-stat-card completion ${getCompletionColor()}`}>
                    <div className="stat-label">Task Completion</div>
                    <div className="stat-value">{completedTasks}/{totalTasks}</div>
                    <div className="stat-sublabel">{completionRate}% completed</div>
                </div>
                <div className={`pickup-stat-card rate ${getPickupRateColor()}`}>
                    <div className="stat-label">Pickup Rate</div>
                    <div className="stat-value">{pickupRate || 0}%</div>
                    <div className="stat-progress">
                        <div 
                            className="stat-progress-bar" 
                            style={{ width: `${pickupRate || 0}%` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PickupStatsCards;

